import _ from 'lodash'

export default {
  methods: {
    isValidNumber(value) {
      if(value === null || value === undefined)
        return false
      if(isNaN(parseFloat(value)))
        return false
      return true
    },

    isEmptyString(value) {
      if(value === null || value === undefined)
        return true
      var text = ('' + value).trim()

      return text == ''
    },

    // Really simply email validation
    // Only use for warnings, the server will handle final validation
    isValidEmail(email) {
      if(email === null || email === undefined)
        return false

      var address = ('' + email).trim().toLowerCase()
      if(address == '')
        return false

      // JB: 28/6/24 - Return false if the email ends in a dot
      // Technically it's correct and follows the specs, but AWS SES throws errors for recipients ending with a dot
      if(address.endsWith('.'))
        return false

      // Regex based on code from below which is based on RFC 2822
      // https://gist.github.com/gregseth/5582254

      var regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
      return regex.test(address)
    },
  }
}